<template>
    <div class="PDFViewer">
        <div v-if="IsMobile">
            <div v-if="GroupedDocuments">
                <h3 class="red">Viewing grouped documents is currently not supported for mobile devices.</h3>
            </div>
            <div v-else>
                <div v-for="pageNumber in PageNumbers">
                    <img :src="GetPageImageURL(pageNumber)" style="max-width:100%; border-style:solid; margin-top:10px;" />
                </div>
            </div>
        </div>
        <div v-else>
            <object class='pdfFile' type='application/pdf' :data="SourceURL" :key="VirtualKey"></object>
        </div>
    </div>
</template>

<script>
    
    import { isMobile } from 'mobile-device-detect';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "SourceFileId",
            "DocumentName",
            "GroupedDocuments"
        ],
        data: function () {
            return {
                PageLength: 0,
                VirtualKey: 1
            }
        },
        methods: {
            GetPageLength() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Files/GetPDFLength", { FileID: this.SourceFileId }, this.GetPageLengthSuccess, () => { }, false);
            },
            GetPageLengthSuccess(response) {
                this.PageLength = response.data.data.PageLength;
            },
            GetPageImageURL(pageIndex) {
                return this.$baseURL + "/api/core/files/GetPDFImage/" + this.CleanString(this.DocumentName) + "?FileID=" + this.SourceFileId + "&PageIndex=" + pageIndex;
            },
            CleanString(input) {
                if (input) {
                    let newString = input.replaceAll("+", "")
                        .replaceAll("/", "")
                        .replaceAll(" ", "");
                    return newString;
                } else {
                    return input;
                }
                
            },
            RefreshPdf() {
                this.VirtualKey++;
            }
        },
        mounted: function () {
            if (this.IsMobile && this.GroupedDocuments == null) {
                this.GetPageLength();
            }
        },

        computed: {
            SourceURL: function () {
                if (this.GroupedDocuments == null) {
                    return this.$baseURL + "/api/core/files/getfilecontent/" + this.CleanString(this.DocumentName) + "?FileID=" + this.SourceFileId;
                } else {
                    if (this.GroupedDocuments.DocIDs) {
                        let docIDsString = this.GroupedDocuments.DocIDs.join('.');
                        return this.$baseURL + "/api/core/files/getcombodocuments/ComboDocuments.pdf?DocIDs=" + docIDsString;
                    }
                    else if (this.GroupedDocuments.SectionName == null) {
                        return this.$baseURL + "/api/core/files/getgroupeddocuments/GroupedDocuments.pdf?ChartID=" + this.GroupedDocuments.ChartID + "&ChapterName=" + this.GroupedDocuments.ChapterName;

                    } else {
                        return this.$baseURL + "/api/core/files/getgroupeddocuments/GroupedDocuments.pdf?ChartID=" + this.GroupedDocuments.ChartID + "&ChapterName=" + this.GroupedDocuments.ChapterName+ "&SectionName=" + this.GroupedDocuments.SectionName;

                    }
                }
            },
            IsMobile: function () {
                return isMobile;
            },
            PageNumbers: function () {
                let pageNumbers = [];
                for (var i = 0; i < this.PageLength; i++) {
                    pageNumbers.push(i)
                }
                return pageNumbers;
            }
        },
        created() {
            let vm = this;
            EventBus.$on('pdf-update-needed', vm.RefreshPdf);
        },
        beforeDestroy() {
            EventBus.$off('pdf-update-needed');
        },

    }
</script>

<style scoped>
    .pdfFile {
        width: 100%;
        height: 80vh;
    }
</style>